export default __webpack_public_path__ + "static/EXP_Pressemeldung_1_1_de-de6eabd5436835b786fdaf8d7fdbc850.png";